import { render, staticRenderFns } from "./clearspace.vue?vue&type=template&id=6121488c&scoped=true"
import script from "./clearspace.vue?vue&type=script&lang=js"
export * from "./clearspace.vue?vue&type=script&lang=js"
import style0 from "./clearspace.vue?vue&type=style&index=0&id=6121488c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121488c",
  null
  
)

export default component.exports